import { config } from '../../Config';

const DeletePublication = async (chatId, authorId) => {
    const url = config.deletePublication;
    const payload = {
        chatId,
        authorId
    };

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Failed to delete publication: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting publication:', error);
        return null;
    }
};

export default DeletePublication;
